import { useQuery } from "@tanstack/react-query";
import { adaptStores } from "src/features/Locations/adapters/adaptStore";
import cmsClient from "src/services/cmsClient";

interface UseAdminStoresParams {
	regionId?: number;
	areaId?: number;
}

const fetchStores = async (regionId?: number, areaId?: number) => {
	const url = "/homepage/admin/store/store/";
	const params: Record<string, number> = {};

	if (regionId !== undefined) params.region = regionId;
	if (areaId !== undefined) params.area = areaId;

	const response = await cmsClient.get<CMSPaginatedData<IStore>>(url, {
		params: Object.keys(params).length > 0 ? params : undefined
	});

	return response.data.results;
};

const useAdminStores = ({ regionId, areaId }: UseAdminStoresParams = {}) => {
	return useQuery(
		["admin-stores", regionId, areaId],
		() => fetchStores(regionId, areaId),
		{
			select: adaptStores,
			staleTime: 10 * 60 * 1000
		}
	);
};

export default useAdminStores;
